export default {
  'accountActivity.recentAccountActivity': 'Saved Criteria',
  'accountActivity.createSearchCriteria': 'Create Search Criteria',
  'accountActivity.reportName': 'Report Name',
  'accountActivity.deleteWarning': 'DELETE REPORT',
  'accountActivity.content': 'report(s) will be deleted and will be permanently removed',
  'accountActivity.deleteMessage': 'Report(s) Deleted Successfully',
  'accountActivity.lock': 'Lock',
  'accountActivity.unLock': 'Unlock'
};
